export default __webpack_public_path__ + "static/media/Rubik-VariableFont_wght.3a8e5377.ttf";